import React from "react";

type BreadCrumbIconProps = React.SVGProps<SVGSVGElement>;

export const BreadCrumbIcon = ({
  width = 20,
  height = 20,
  ...props
}: BreadCrumbIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.2522 12.226C2.98971 10.908 2.85811 10.2486 3.2312 9.80197C3.25659 9.77217 3.28321 9.74345 3.311 9.71588C3.7261 9.30078 4.46109 9.30078 5.93037 9.30078H14.0699C15.5398 9.30078 16.2748 9.30078 16.6892 9.71588C16.7172 9.74388 16.7436 9.77257 16.7683 9.80197C17.1421 10.2486 17.0105 10.908 16.7473 12.226C16.3693 14.1216 16.1803 15.0687 15.4677 15.6511C15.4192 15.6908 15.369 15.7288 15.3172 15.7652C14.5613 16.3007 13.5043 16.3007 11.3917 16.3007H8.60853C6.49526 16.3007 5.43898 16.3007 4.68299 15.7652C4.63155 15.7289 4.58136 15.6908 4.53249 15.6511C3.8199 15.0687 3.6309 14.1216 3.2529 12.226H3.2522Z"
      stroke="#253858"
      strokeWidth="1.2"
    />
    <path
      d="M4.40002 9.3011V5.45115C4.40002 4.98703 4.5844 4.54191 4.91258 4.21373C5.24077 3.88554 5.68588 3.70117 6.15 3.70117H7.85098C8.0814 3.70114 8.30828 3.75798 8.51147 3.86666C8.71465 3.97533 8.88788 4.13248 9.01576 4.32416L9.99995 5.80114M9.99995 5.80114H7.54998M9.99995 5.80114H13.8499C14.314 5.80114 14.7591 5.98552 15.0873 6.3137C15.4155 6.64188 15.5999 7.087 15.5999 7.55112V9.3011"
      stroke="#253858"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BreadCrumbIcon;
